import React from 'react';
import styled, { keyframes } from 'styled-components';
import { useTheme } from '../../ThemeContext';

const PremiumButton = ({ onClickFn, btnText, loading, disabled }) => {
  const { darkMode } = useTheme();
  const isOut = btnText && btnText.toLowerCase() === 'out';

  return (
    <StyledWrapper $darkMode={darkMode} $isOut={isOut} $disabled={disabled || loading}>
      <button
        className="premium-btn"
        onClick={onClickFn}
        disabled={disabled || loading}
      >
        {loading ? (
          <div className="spinner"></div>
        ) : (
          <span>{btnText}</span>
        )}
        {!loading && <div className="fill-block"></div>}
      </button>
    </StyledWrapper>
  );
};

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const StyledWrapper = styled.div`
  display: inline-block;
  
  .premium-btn {
    position: relative;
    padding: 8px 20px;
    font-size: 14px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 1px;
    color: ${props => props.$disabled ? '#9ca3af' : (props.$isOut ? '#ef4444' : '#10b981')};
    background-color: ${props => props.$disabled ? '#e5e7eb' : 'transparent'};
    border: 2px solid ${props => props.$disabled ? '#d1d5db' : (props.$isOut ? '#ef4444' : '#10b981')};
    border-radius: 8px;
    cursor: ${props => props.$disabled ? 'not-allowed' : 'pointer'};
    overflow: hidden;
    transition: all 0.6s ease;
    z-index: 1;
    outline: none;
    min-width: 90px;
    min-height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    
    box-shadow: ${props => props.$disabled ? 'none' : '0 4px 6px -1px rgba(0, 0, 0, 0.1)'};

    &:hover {
      color: ${props => props.$disabled ? '#9ca3af' : '#ffffff'};
      border-color: ${props => props.$disabled ? '#d1d5db' : (props.$isOut ? '#b91c1c' : '#059669')};
      transform: ${props => props.$disabled ? 'none' : 'translateY(-2px)'};
      box-shadow: ${props => props.$disabled ? 'none' : (props.$isOut ? '0 10px 15px -3px rgba(239, 68, 68, 0.4)' : '0 10px 15px -3px rgba(16, 185, 129, 0.4)')};
    }

    &:active {
      transform: ${props => props.$disabled ? 'none' : 'translateY(1px)'};
    }

    .fill-block {
      position: absolute;
      left: 0;
      top: 100%;
      width: 100%;
      height: 100%; 
      background-color: ${props => props.$isOut ? '#ef4444' : '#10b981'};
      border-radius: 0; 
      z-index: -1;
      transition: top 0.8s cubic-bezier(0.19, 1, 0.22, 1);
    }

    &:hover .fill-block {
      top: 0;
    }

    .spinner {
      width: 20px;
      height: 20px;
      border: 3px solid rgba(156, 163, 175, 0.3);
      border-radius: 50%;
      border-top-color: #6b7280;
      animation: ${spin} 0.8s linear infinite;
    }
  }
`;

export default PremiumButton;
